import { computed, effect, Inject, Injectable, OnDestroy, signal } from '@angular/core';
import { BehaviorSubject, startWith, Subject, Subscription } from 'rxjs';
import { StorageService } from './storage.service';
import { Router } from '@angular/router';
import { AppConfig, CONFIG_TOKEN } from '../setup/config';
import {
  IClaimsAccess, IClaimsRefresh, IClaimSubAccess, IClaimSubRefresh, IResponseToken,
  storageTokenAccess, storageTokenName,
  storageTokenRefresh,
  User, UserClaim, sailsSid
} from './me.lib';
import { jwtDecode } from 'jwt-decode';
import moment from 'moment';
import _ from 'lodash'
import { CookieService } from 'ngx-cookie-service';
import { LoggerService } from '../shared/logger.service';

@Injectable({
  providedIn: 'root'
})
export class AuthTokenService implements OnDestroy {

  private _tokenUser = new BehaviorSubject<string | null>(this.storage.get(storageTokenName));
  private _tokenAccess = new BehaviorSubject<string | null>(this.storage.get(storageTokenAccess));
  private _tokenRefresh = new BehaviorSubject<string | null>(this.storage.get(storageTokenRefresh));

  private previousStatus: boolean = this.isLoggedIn;

  public readonly loggedInSignal = signal<boolean>(this._isLoggedIn());
  public readonly loggedInComputed = computed(() => {
    return this.loggedInSignal();
  })
  private _loggedIn: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(this._isLoggedIn());
  // get isLoggedIn$() {
  //   return this._loggedIn.asObservable();
  // }
  get loggedIn() {
    if (this._loggedIn)
      return this._loggedIn.getValue();
    return false;
  }
  set loggedIn(val: boolean) {
    if (this._loggedIn)
      this._loggedIn.next(val);
  }

  private _user: BehaviorSubject<User | null> = new BehaviorSubject<User | null>(this.getClaims());
  // get user$() {
  //   return this._user.asObservable();
  // }
  get user() {
    return this._user.getValue();
  }
  set user(val: User | null) {
    this._user.next(val);
  }

  // public userSignal = signal<User | null>(this.getClaims());
  // public readonly userComputed = computed(() => {
  //   return this.userSignal();
  // });

  private _subs: Subscription[] = [];
  intervalId: any;

  constructor(
    private storage: StorageService,
    private logger: LoggerService,
    private router: Router,
    private cookieService: CookieService,
    @Inject(CONFIG_TOKEN) private config: AppConfig
  ) {
    // this.intervalId = setInterval(() => {
    //   this.logger.debug('Call Function Every Five Seconds', this.expiresIn());
    //   this.tokenCheck();
    //   // this.loggedIn = this.isLoggedIn;
    // }, this.config.pollInterval);
    // this.tokenCheck();

    this._subs.push(this._loggedIn.subscribe(status => {
      this.logger.debug('status changed: **>> ', status, this.previousStatus);
      if (this.previousStatus !== status && !status) {
        this.router.navigate(['/signed-out']);
        // this.router.navigate(['/login']);
        // this.router.navigate(['/home-logged-out']);
      }
      this.previousStatus = status;
    }));

    effect(() => {
      this.logger.debug(`constructor:effect fired...`);
      // this.logger.debug(`constructor:effect:tokenComputed: `, this.tokenComputed());
      // this.logger.debug(`constructor:effect:tokenAccessComputed: `, this.tokenAccessComputed());
      // this.logger.debug(`constructor:effect:tokenRefreshComputed: `, this.tokenRefreshComputed());
      this.logger.debug(`getClaimsFromTokenComputed: `, this.getClaimsFromTokenComputed());
      this.logger.debug(`accessComputed: `, this.accessComputed());
      this.logger.debug(`claimsComputed: `, this.userComputed());
      this.logger.debug(`loggedInComputed: `, this.loggedInComputed());
    })
  }

  ngOnDestroy(): void {
    this.logger.debug('ngOnDestroy...');
    if (this.intervalId) {
      clearInterval(this.intervalId);
    }
    this._subs.forEach(s => s.unsubscribe());
  }

  //#region Tokens

  tokenSignal = signal<string | null>(this.storage.get(storageTokenName));
  public readonly tokenComputed = computed(() => {
    // if (!this.tokenSignal()) {
    //   this.tokenSignal.set(this.storage.get(storageTokenName));
    // }
    return this.tokenSignal();
  });
  updateTokenSignal(val: string | null) {
    this.tokenSignal.set(val);
    if (val) {
      this.storage.set(storageTokenName, val);
    } else {
      this.storage.remove(storageTokenName);
    }
  }

  get tokenUser$() {
    return this._tokenUser.asObservable();
  }
  get tokenUser() {
    if (this._tokenUser) {
      if (!this._tokenUser.value) {
        this.tokenUser = this.storage.get(storageTokenName);
      }
      return this._tokenUser.getValue();
    }
    return null;
  }
  set tokenUser(val: string | null) {
    this._tokenUser.next(val);
    if (val)
      this.storage.set(storageTokenName, val);
    else
      this.storage.remove(storageTokenName);
  }

  tokenAccessSignal = signal<string | null>(this.storage.get(storageTokenAccess));
  public readonly tokenAccessComputed = computed(() => {
    // if (!this.tokenAccessSignal()) {
    //   this.tokenAccessSignal.set(this.storage.get(storageTokenAccess));
    // }
    return this.tokenAccessSignal();
  });
  updateTokenAccessSignal(val: string | null) {
    this.tokenAccessSignal.set(val);
    if (val) {
      this.storage.set(storageTokenAccess, val);
    } else {
      this.storage.remove(storageTokenAccess);
    }
  }

  get tokenAccess$() {
    return this._tokenAccess.asObservable();
  }
  get tokenAccess() {
    if (this._tokenAccess) {
      if (!this._tokenAccess.getValue()) {
        this.tokenAccess = this.storage.get(storageTokenAccess);
      }
      return this._tokenAccess.getValue();
    }
    return null;
  }
  set tokenAccess(val: string | null) {
    this._tokenAccess.next(val);
    if (val)
      this.storage.set(storageTokenAccess, val);
    else
      this.storage.remove(storageTokenAccess);
  }

  tokenRefreshSignal = signal<string | null>(this.storage.get(storageTokenRefresh));
  public readonly tokenRefreshComputed = computed(() => {
    // if (!this.tokenRefreshSignal()) {
    //   this.tokenRefreshSignal.set(this.storage.get(storageTokenRefresh));
    // }
    return this.tokenRefreshSignal();
  });
  updateTokenRefreshSignal(val: string | null) {
    this.tokenRefreshSignal.set(val);
    if (val) {
      this.storage.set(storageTokenRefresh, val);
    } else {
      this.storage.remove(storageTokenRefresh);
    }
  }

  get tokenRefresh$() {
    return this._tokenRefresh.asObservable();
  }
  get tokenRefresh() {
    if (this._tokenRefresh) {
      if (!this._tokenRefresh.getValue()) {
        this.tokenRefresh = this.storage.get(storageTokenRefresh);
      }
      return this._tokenRefresh.getValue();
    }
    return null;
  }
  set tokenRefresh(val: string | null) {
    this._tokenRefresh.next(val);
    if (val)
      this.storage.set(storageTokenRefresh, val);
    else
      this.storage.remove(storageTokenRefresh);
  }

  //#endregion

  //#region Login Claims

  public readonly userComputed = computed<User | null>(() => {
    let claims = this.getClaimsFromTokenComputed();
    // this.logger.debug(`userComputed:claims: `, claims);
    if (claims && claims.sub) {
      return User.createFromSub(claims.sub);
    }
    return null;
  });

  public claimsSignal = signal<UserClaim | null>(null);

  getToken(): string | null {
    return this.tokenUser;
  }

  public readonly tokenPayload = computed<UserClaim | null>(<T = UserClaim>() => {
    if (!this.tokenSignal()) {
      return null;
    }
    try {
      let decodedToken = jwtDecode(this.tokenSignal()!);
      return <T>decodedToken;
    } catch (error) {
      this.logger.error('getTokenPayload:error: ', error);
      return null;
    }
  });

  getTokenPayload<T = UserClaim>(token: string): T | null {
    try {
      // this.logger.log('getTokenPayload:token: ', token, token === 'undefined');
      if (!token || token === 'undefined') {
        return null;
      }
      let decodedToken = jwtDecode(token);
      return <T>decodedToken;
    } catch (error) {
      this.logger.error('getTokenPayload:error: ', error);
      return null;
    }
  }

  private readonly getClaimsFromTokenComputed = computed<UserClaim | null>(() => {
    let tokenPayload = this.tokenPayload();
    this.logger.debug(`getClaimsFromTokenComputed:tokenPayload: `, tokenPayload);
    if (tokenPayload) {
      try {
        return UserClaim.create(tokenPayload);
      } catch (error) {
        this.logger.error('getClaimsFromTokenComputed:error: ', error);
        return null;
      }
    }
    return null;
  });

  getClaimsFromToken(): UserClaim | null {
    let token = this.getToken();
    let claims: UserClaim | null = null; //  <UserClaim>{};
    if (token && token !== 'undefined') {
      try {
        claims = UserClaim.create(this.getTokenPayload<any>(token));
      } catch (e) {
        this.logger.error('getClaimsFromToken:error: ', e);
        return null;
      }
    }
    // this.logger.debug('getClaimsFromToken: claims: ', claims, claims?.isExpired);
    if (claims) { // && !claims.isExpired) {
      return claims;
    }
    // this.removeToken();
    return null;
  }

  getClaims(): User | null {
    let claims = this.getClaimsFromToken();
    if (claims && claims.sub) {
      return User.createFromSub(claims.sub);
    }
    return null;
  }

  //#endregion

  //#region Permissions Token

  getAccess(): string | null {
    return this.tokenAccess;
  }

  public readonly tokenAccessPayload = computed<IClaimsAccess | null>(<T = IClaimsAccess>() => {
    if (!this.tokenAccessSignal()) {
      return null;
    }
    try {
      let decodedToken = jwtDecode(this.tokenAccessSignal()!);
      return <T>decodedToken;
    } catch (error) {
      this.logger.error('tokenAccessPayload:error: ', error);
      return null;
    }
  });

  private readonly getClaimsFromAccessTokenComputed = computed<IClaimsAccess | null>(() => {
    return this.tokenAccessPayload();
  });

  public readonly accessComputed = computed<IClaimSubAccess | undefined>(() => {
    let claims = this.getClaimsFromAccessTokenComputed();
    if (claims && claims.sub) {
      return claims.sub;
    }
    return undefined;
  });

  getAccessClaims(): IClaimSubAccess | undefined {
    let claims = this.getClaimsFromAccess();
    if (claims && claims.sub) {
      return claims.sub;
    }
    return undefined;
  }

  getClaimsFromAccess(): IClaimsAccess | null {
    let token = this.getAccess();
    let claims: IClaimsAccess = <IClaimsAccess>{};
    if (token) {
      try {
        claims = this.getTokenPayload<any>(token);
      } catch (e) {
        return null;
      }
    }
    return claims;
  }

  canIAccess(entity?: string): boolean {
    // this.logger.debug('canIAccess:entity: ', entity);
    if (!entity)
      return true;
    let result = this.isLoggedIn
      && _.indexOf(this.accessComputed()?.menuAccess, entity) !== -1;
    // && _.indexOf(this.getAccessClaims()?.menuAccess, entity) !== -1;
    // this.logger.debug('canIAccess:result: ', entity, result);
    return result;
  };

  //#endregion

  //#region Refresh Token

  getRefreshToken(): string | null {
    return this.tokenRefresh;
  }

  public readonly tokenRefreshPayload = computed<IClaimsRefresh | null>(<T = IClaimsRefresh>() => {
    if (!this.tokenRefreshSignal()) {
      return null;
    }
    try {
      let decodedToken = jwtDecode(this.tokenRefreshSignal()!);
      return <T>decodedToken;
    } catch (error) {
      this.logger.error('tokenAccessPayload:error: ', error);
      return null;
    }
  });

  getRefreshClaims(): IClaimSubRefresh | undefined {
    let claims = this.getClaimsFromRefresh();
    if (claims && claims.sub) {
      return claims.sub;
    }
    return undefined;
  }

  getClaimsFromRefresh(): IClaimsRefresh | null {
    let token = this.getRefreshToken();
    let claims: IClaimsRefresh = <IClaimsRefresh>{};
    if (token) {
      try {
        claims = this.getTokenPayload<any>(token);
      } catch (e) {
        return null;
      }
    }
    return claims;
  }

  //#endregion

  //#region General Functions

  parseToken(token?: string): any {
    if (!token)
      throw 'expected token';
    let decodedToken = jwtDecode(token);
    this.logger.debug('parseToken:decodedToken: ', decodedToken);
    const isExpired = decodedToken.exp ? decodedToken.exp < Date.now() / 1000 : true;
    if (!isExpired && decodedToken.sub) {
      return decodedToken.sub;
    }
    return null;
  }

  isClaimsExpired(claims: any): boolean {
    if (!claims)
      throw 'expected token';
    if (!claims || Object.keys(claims).length === 0)
      return true;
    return moment().unix() > claims.exp;
    // return Date.now() > claims.exp;
  }

  hasClaims(): boolean {
    let claims = this.getClaimsFromToken(); // this.getClaimsFromTokenComputed(); // this.getClaimsFromToken();
    // this.logger.debug('hasClaims: ', claims)
    if (claims)
      return true; //  Object.keys(claims).length === 0;
    return false;
  }

  isExpired(): boolean {
    let claims = this.getClaimsFromToken(); // this.getClaimsFromTokenComputed(); // this.getClaimsFromToken()
    if (claims) {
      // this.logger.debug('isExpired: ', claims.isExpired, moment().unix() > claims.exp);
      return claims.isExpired;
    }
    return true;
  }

  hasExpired(token: string): boolean {
    let decodedToken = jwtDecode(token);
    let returning = decodedToken.exp ? decodedToken.exp < Date.now() / 1000 : true;
    // this.logger.debug('hasExpired:decodedToken: ', decodedToken, decodedToken.exp ? decodedToken.exp - Date.now() / 1000 : 0);
    // this.logger.debug('hasExpired:returning: ', returning);
    return returning;
  }

  expiresIn(): number {
    let claims = this.getClaimsFromToken(); // this.getClaimsFromTokenComputed(); // this.getClaimsFromToken();
    if (!claims)
      return -1;
    return claims.expiresIn;
  }

  setToken(token: IResponseToken): void {
    if (!token)
      return;

    const { meToken, accessToken,
      refreshToken
    } = token;
    this.tokenUser = meToken;
    // this.tokenSignal.set(meToken);
    this.updateTokenSignal(meToken);
    this.tokenAccess = accessToken;
    // this.tokenAccessSignal.set(accessToken);
    this.updateTokenAccessSignal(accessToken);
    this.tokenRefresh = refreshToken;
    // this.tokenRefreshSignal.set(refreshToken);
    this.updateTokenRefreshSignal(refreshToken);
    this.user = this.userComputed();
    let claims = this.getClaimsFromTokenComputed();
    if (!claims)
      return;
    const { exp } = claims;
    let expiresIn: Date = moment.unix(exp).toDate(); //.toISOString(); //  moment().add(1, 'd').toISOString(); //.format('YYYY-MM-DDTHH:MM:SS');
    // this.cookieService.set(storageTokenName, meToken, { expires: expiresIn })
    this.loggedIn = true;
    this.loggedInSignal.set(true);
  }

  setAccess(accessToken: string): void {
    if (!accessToken)
      return;
    this.tokenAccess = accessToken;
    this.tokenAccessSignal.set(accessToken);

    let claims = this.getClaimsFromToken(); // this.getClaimsFromTokenComputed(); // this.getClaimsFromToken();
    if (!claims)
      return;

    const { exp } = claims;
    let expiresIn = moment.unix(exp).toDate(); //.toISOString(); //  moment().add(1, 'd').toISOString(); //.format('YYYY-MM-DDTHH:MM:SS');
    this.cookieService.set(storageTokenAccess, accessToken, { expires: expiresIn })
  }

  isAuthenticated(): boolean {
    // this.logger.debug('isAuthenticated? ', !!this.getToken(), this.getToken());
    let returning = !!this.getToken();
    // this.logger.debug('isAuthenticated? ', returning);
    return returning;
    // this.loggedIn = !!this.getToken();
    // return this.loggedIn;
  }

  removeToken(): void {
    this.logger.debug('removeToken...');
    this.loggedIn = false;
    this.loggedInSignal.set(false);

    this.tokenUser = null;
    this.updateTokenSignal(null);
    this.tokenAccess = null;
    this.updateTokenAccessSignal(null);
    this.tokenRefresh = null;
    this.updateTokenRefreshSignal(null);

    this.cookieService.delete(storageTokenName);
    this.cookieService.delete(storageTokenAccess);
    this.cookieService.delete(storageTokenRefresh);
    this.user = null;
  }

  tokenCheck(): void {
    this.logger.debug('tokenCheck: ', this.hasClaims(), this.isExpired(), this.expiresIn());
    if (this.hasClaims() && this.isExpired()) {
      // if (!this.hasClaims() || (this.hasClaims() && this.isExpired())) {
      // this.logger.debug('tokenCheck: ', this.hasClaims());
      this.removeToken();

      this.router.navigate(['/signed-out']);
      // this.router.navigate(['/login']);
      // this.router.navigate(['/home-logged-out']);
      this.loggedIn = false;
      this.loggedInSignal.set(false);
    }
  }

  get isLoggedIn(): boolean {
    // this.logger.debug('isLoggedIn: ', this.hasClaims(), this.isExpired(), this.isAuthenticated());
    // this.loggedIn = this._isLoggedIn();
    // return this.loggedIn;
    return this._isLoggedIn();
    // if (!this.hasClaims() || this.isExpired()) {
    //   this.loggedIn = false;
    //   return false;
    // }
    // return this.isAuthenticated();
  }

  get hasLoginToken(): boolean {
    return this.isAuthenticated();
  }

  private _isLoggedIn(): boolean {
    if (!this.hasClaims() || this.isExpired()) {
      return false;
    }
    return this.isAuthenticated();
  }

  //#endregion

}
